import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsSquareenixComponent } from './simple-icons-squareenix.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsSquareenixComponent ],
    exports:      [ SimpleIconsSquareenixComponent ],
    bootstrap:    []
})
export class SimpleIconsSquareenixModule {}
